import React from "react";
import "../../pages/doctor-console/DoctorConsole.scss";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import { Row, Col } from "../../components/RowCol";
import { Table, Button } from "react-bootstrap";
import { Icon, TableHead } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useState } from "react";
import HiTypeHeader from "../../pages/doctor-console/Utils/HiTypeHeader";
import {
  formatDateIST,
  separateCamelCase,
} from "../../pages/doctor-console/Utils/UtilsFunctions";
import {
  AttachmentActionButtons,
  ModalActionButtons,
} from "../../pages/doctor-console/Utils/AttachmentActions";
import { DoctorconsoleGrid } from "../../pages/doctor-console/StyledComponents";
const DischargeSummary = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [currentAttachment, setCurrentAttachment] = useState(null);
  const dischargeSummaryData = props.dischargeSummaryData;
  console.log("Discharge Summary Data", dischargeSummaryData);
  const viewAttachment = (attach) => {
    // console.log(attachment);
    let attachment = attach.content[0];
    setCurrentAttachment(attachment);
    // Wrap the content in a div with overflow for scrollability
    let modalContent;
    if (attachment.content_type === "application/pdf") {
      const url = `data:application/pdf;base64,${attachment.data}#toolbar=0`;
      modalContent = (
        <iframe width="100%" height="100%" src={url} title={attach.id}></iframe>
      );
    } else if (
      attachment.content_type === "image/jpeg" ||
      attachment.content_type === "image/jpg" ||
      attachment.content_type === "image/png"
    ) {
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      // Display image files
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "80%",
            maxHeight: "700px",
          }}
        >
          <img src={url} alt={attach.id} title={attach.id} />
        </div>
      );
    } else {
      // Default to displaying it as an image if content type is unknown
      const url = `data:${attachment.content_type};base64,${attachment.data}`;
      modalContent = (
        <div
          style={{
            overflow: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <img src={url} alt="Attachment" />
        </div>
      );
    }

    setModalContent(modalContent);
    setShowModal(true);
  };
  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent(null);
    setCurrentAttachment(null);
  };

  function processAllFHIRData(data) {
    const summaryData = [];

    data.entry.forEach((entry) => {
      const resourceType = entry.resource.resourceType;
      const resourceObject = entry;

      const summaryEntry = {};
      summaryEntry[resourceType] = resourceObject;

      summaryData.push(summaryEntry);
    });

    return summaryData;
  }

  // Example usage
  // const dischargeData = processAllFHIRData(dischargeFhir);
  // console.log("Discharge Data", dischargeData);
  // useState(() => {
  //   const compositionObject = dischargeData.find((entry) =>
  //     entry.hasOwnProperty("Composition")
  //   );

  //   const diagnosis = [];
  //   const procedures = [];
  //   const dsMedicines = [];
  //   const dsDocuments = [];
  //   // const diagnosisSection = compositionObject.Composition.section.find(
  //   //     (section) => section.title === "Chief complaints"
  //   //   );
  //   // if (diagnosisSection) {
  //   //   const diagnosisIds = diagnosisSection.entry.map((obj) => {
  //   //     // Extracting the ID from the reference
  //   //     return obj.reference;
  //   //   });
  //   //   console.log("Diagnosis Ids", diagnosisIds);
  //   //   // Assuming allMedications is an array containing all medication objects

  //   //   diagnosisIds.map((id) => {
  //   //     let diagnos = dischargeData.find(
  //   //       (entry) =>
  //   //         entry.hasOwnProperty("Condition") && entry.Condition.fullurl === id
  //   //     );
  //   //     console.log("Diagnos", diagnos);
  //   //     diagnosis.push(diagnos.Condition);
  //   //   });
  //   //   // console.log("Diagnosis", diagnosis);
  //   // }
  //   // const proceduresSection = compositionObject.Composition.section.find(
  //   //     (section) => section.title === "Chief complaints"
  //   //   );
  //   // if (diagnosisSection) {
  //   //   const diagnosisIds = diagnosisSection.entry.map((obj) => {
  //   //     // Extracting the ID from the reference
  //   //     return obj.reference;
  //   //   });
  //   //   console.log("Diagnosis Ids", diagnosisIds);
  //   //   // Assuming allMedications is an array containing all medication objects

  //   //   diagnosisIds.map((id) => {
  //   //     let diagnos = dischargeData.find(
  //   //       (entry) =>
  //   //         entry.hasOwnProperty("Condition") && entry.Condition.fullurl === id
  //   //     );
  //   //     console.log("Diagnos", diagnos);
  //   //     diagnosis.push(diagnos.Condition);
  //   //   });
  //   //   // console.log("Diagnosis", diagnosis);
  //   // }
  // }, [dischargeData]);
  return (
    <>
      <DoctorconsoleGrid>
        {dischargeSummaryData !== undefined && dischargeSummaryData !== null ? (
          <>
            <HiTypeHeader
              date={dischargeSummaryData.Date}
              name={"Discharge Summary Record"}
              encounter={dischargeSummaryData.Encounter}
              organizationDetails={dischargeSummaryData.Organization}
              practitionerDetails={dischargeSummaryData.Practitioner}
            />
            {Object.keys(dischargeSummaryData).map(
              (categoryKey) =>
                ![
                  "Encounter",
                  "Date",
                  "Organization",
                  "Practitioner",
                  "Patient",
                ].some(
                  (substring) =>
                    substring === categoryKey.match(/\(([^)]+)\)/)?.[1] ||
                    substring == categoryKey // Extract and check in the same line
                ) && (
                  <Accordion className="innermost-accordion" defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      className="innermost-accordion-summary"
                    >
                      <Typography
                        sx={{ color: "white" }}
                        className="accordion-section-title"
                      >
                        {categoryKey}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Row
                        style={{
                          marginTop: "30px",
                          // backgroundImage:
                          //   "url('../../assets/images/backgrounds/2.jpg')",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <Col
                          area="span 12"
                          style={{ border: "2px solid #76787a" }}
                        >
                          {categoryKey.includes("DocumentReference") ? (
                            <div
                              style={{
                                marginTop: "20px",
                                fontWeight: "bold",
                                marginBottom: "50px",
                                fontSize: "16px",
                              }}
                            >
                              Attachments :{" "}
                              {dischargeSummaryData[categoryKey].length > 0
                                ? dischargeSummaryData[categoryKey].map(
                                    (attachment, attIdx) => (
                                      <span
                                        key={attIdx}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "4px",
                                          marginRight: "12px",
                                        }}
                                      >
                                        <button
                                          style={{
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            padding: "5px 10px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            viewAttachment(attachment)
                                          }
                                        >
                                          <i className="fas fa-file"></i>
                                        </button>
                                        <AttachmentActionButtons
                                          base64Data={
                                            attachment?.content?.[0]?.data
                                          }
                                          contentType={
                                            attachment?.content?.[0]
                                              ?.content_type
                                          }
                                          filename={
                                            attachment?.id || "attachment"
                                          }
                                        />
                                      </span>
                                    )
                                  )
                                : "No attachments found!"}
                            </div>
                          ) : (
                            <Table responsive size="lg">
                              <TableHead
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  gridTemplateColumns:
                                    "250px 250px 250px 120px 120px",
                                  justifyContent: "center",
                                }}
                              >
                                {categoryKey.includes("Condition") ? (
                                  <>
                                    <td>Name</td>
                                    <td>Clinical Status</td>
                                    <td>Recorded Date</td>
                                  </>
                                ) : categoryKey.includes("CarePlan") ? (
                                  <>
                                    <td>Name</td>
                                    <td>Status</td>
                                    <td>Description</td>
                                  </>
                                ) : categoryKey.includes("Specimen") ? (
                                  <td>Name</td>
                                ) : categoryKey.includes(
                                    "MedicationRequest"
                                  ) ? (
                                  <>
                                    <td>Medication</td>
                                    <td>Dosage and Route</td>
                                    <td>Reason</td>
                                    <td>Authored Date</td>
                                  </>
                                ) : categoryKey.includes("Procedure") ? (
                                  <>
                                    <td>Name</td>
                                    <td>Status</td>
                                    <td>Performed On</td>
                                  </>
                                ) : categoryKey !== "Encounter" &&
                                  categoryKey != "DiagnosticReport" ? (
                                  <>
                                    <td>Name</td>
                                    <td>Status</td>
                                  </>
                                ) : null}
                              </TableHead>
                              <tbody>
                                {dischargeSummaryData?.[categoryKey]?.map(
                                  (item) => (
                                    <tr key={item.id}>
                                      {categoryKey.includes("Condition") ? (
                                        <>
                                          <td>
                                            {item?.code?.[0]?.display ||
                                              item.code[0]}
                                          </td>
                                          <td>
                                            {item?.clinical_status?.[0]?.display.trim() ||
                                              "-"}
                                          </td>
                                          <td>
                                            {item.recorded_date
                                              ? formatDate(item.recorded_date)
                                              : "-"}
                                          </td>
                                        </>
                                      ) : categoryKey.includes("Procedure") ? (
                                        <>
                                          <td>
                                            {item?.code?.[0]?.display ||
                                              item.code[0]}
                                          </td>
                                          <td>{item?.status}</td>
                                          <td>
                                            {item?.performed_datetime
                                              ? formatDateIST(
                                                  item.performed_datetime
                                                )
                                              : "-"}
                                          </td>
                                        </>
                                      ) : categoryKey.includes("CarePlan") ? (
                                        <>
                                          <td>
                                            {item?.category?.[0]?.display ||
                                              item.category[0]}
                                          </td>
                                          <td>{item?.status}</td>
                                          <td>{item?.description || "-"}</td>
                                        </>
                                      ) : categoryKey.includes("Specimen") ? (
                                        <td>
                                          {item?.code?.[0]?.display ||
                                            item.code[0]}
                                        </td>
                                      ) : categoryKey.includes(
                                          "MedicationRequest"
                                        ) ? (
                                        <>
                                          <td>
                                            {item?.medication?.display ||
                                              item.medication ||
                                              item?.code?.[0]?.display ||
                                              item.code[0]}
                                          </td>
                                          <td>
                                            {item?.dosage?.[0]}
                                            {item?.dosage?.[1]?.display
                                              ? ` ${item.dosage[1].display}`
                                              : ""}
                                          </td>
                                          <td>
                                            {item?.reason_code?.length > 0
                                              ? item.reason_code.join(", ")
                                              : "-"}
                                          </td>
                                          <td>
                                            {item.authored_on
                                              ? formatDateIST(item.authored_on)
                                              : "-"}
                                          </td>
                                        </>
                                      ) : categoryKey !== "Encounter" &&
                                        categoryKey != "DiagnosticReport" ? (
                                        <>
                                          <td>
                                            {item?.code?.[0]?.display ||
                                              item.code[0]}
                                          </td>
                                          <td>{item?.status}</td>
                                        </>
                                      ) : null}
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          )}

                          {categoryKey.includes("DiagnosticReport") &&
                            (dischargeSummaryData[categoryKey].length > 0 ? (
                              dischargeSummaryData[categoryKey].map(
                                (report, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      marginTop: "20px",
                                      fontWeight: "bold",
                                      marginBottom: "50px",
                                      fontSize: "16px",
                                    }}
                                  >
                                    <Table
                                      responsive
                                      size="lg"
                                      style={{ margin: "20px 7px" }}
                                    >
                                      <TableHead
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                          gridTemplateColumns:
                                            "250px 250px 250px 120px 120px",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <td>Name</td>
                                        <td>Value Quantity</td>
                                        <td>Reference Range</td>
                                        <td>Status</td>
                                      </TableHead>
                                      <tbody style={{ fontWeight: "normal" }}>
                                        {report.results.map((result, index) => (
                                          <tr key={index}>
                                            <td>
                                              {result?.code?.[
                                                result.code.length - 1
                                              ]?.text ||
                                                result?.code?.[
                                                  result.code.length - 1
                                                ]?.display ||
                                                "-"}
                                            </td>
                                            <td>
                                              {result?.value_quantity ? (
                                                <ul>
                                                  {Object.entries(
                                                    result.value_quantity
                                                  ).map(
                                                    ([key, value]) =>
                                                      key !== "code" && (
                                                        <li key={key}>
                                                          <strong>
                                                            {key}:
                                                          </strong>{" "}
                                                          {value}
                                                        </li>
                                                      )
                                                  )}
                                                </ul>
                                              ) : (
                                                "-"
                                              )}
                                            </td>
                                            <td>
                                              <ul>
                                                <li>
                                                  <strong>High-</strong> Unit:{" "}
                                                  {result?.reference_range?.[0]
                                                    ?.high?.unit ?? "-"}
                                                  , Value:{" "}
                                                  {result?.reference_range?.[0]
                                                    ?.high?.value ?? "-"}
                                                </li>
                                                <li>
                                                  <strong>Low-</strong> Unit:{" "}
                                                  {result?.reference_range?.[1]
                                                    ?.low?.unit ?? "-"}
                                                  , Value:{" "}
                                                  {result?.reference_range?.[1]
                                                    ?.low?.value ?? "-"}
                                                </li>
                                              </ul>
                                            </td>

                                            {/* Render Status */}
                                            <td>{result?.status ?? "-"}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  </div>
                                )
                              )
                            ) : (
                              <p>No results found!</p>
                            ))}
                        </Col>
                      </Row>
                    </AccordionDetails>
                  </Accordion>
                )
            )}
          </>
        ) : (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#3AC8BA",
              fontWeight: "bold",
              fontSize: "25px",
            }}
          >
            No Discharge Summary found!
          </div>
        )}
      </DoctorconsoleGrid>

      <Modal open={showModal} onClose={closeModal}>
        <Box className="modal-box">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "4px",
              padding: "8px 12px",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            {currentAttachment && (
              <ModalActionButtons
                base64Data={currentAttachment.data}
                contentType={currentAttachment.content_type}
                filename="attachment"
              />
            )}
            <IconButton onClick={closeModal}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography variant="h6">PDF Viewer</Typography> */}

          <div style={{ flex: 1 }}>{modalContent}</div>
        </Box>
      </Modal>
    </>
  );
};

export default DischargeSummary;
